var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.relatives
    ? _c("div", [
        _vm.data
          ? _c(
              "div",
              [
                _c("Top"),
                _vm._v(" "),
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "margin-top-50" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "header-wrapper" }, [
                        _c("h1", {
                          staticClass: "text-primary-fh left-header",
                          domProps: {
                            innerHTML: _vm._s(_vm.data.familytree.inviteheader)
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.data.familytree.inviteInfoText)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body text-left" }, [
                          _c("h6", { staticClass: "card-title" }, [
                            _vm._v("Personligt meddelande (rekommenderat)")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.personalMessage,
                                expression: "personalMessage"
                              }
                            ],
                            staticClass:
                              "form-control form-control-lg personal-message",
                            attrs: {
                              type: "text",
                              placeholder: "Egen text till din släkting.."
                            },
                            domProps: { value: _vm.personalMessage },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.personalMessage = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("h6", { staticClass: "text-dark" }, [
                            _vm._v("Förhandsvisning")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card override-card" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-body override-card-body text-left"
                              },
                              [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.data.familytree.topPreviewText.replace(
                                        "{fullName}",
                                        _vm.fullname + ":"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c("p", {
                                  domProps: {
                                    textContent: _vm._s(_vm.personalMessage)
                                  }
                                }),
                                _vm._v(" "),
                                _vm.personalMessage.length < 1
                                  ? _c("p", [
                                      _c("i", { staticClass: "text-muted" }, [
                                        _vm._v("Ditt personliga meddelande..")
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.data.familytree.bottomPreviewText.replace(
                                        "{invitationLink}",
                                        "[Länk kommer här]"
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _vm.isGenNegativeIndexPatient
                        ? _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "card-body text-left" }, [
                              _c("span", {
                                staticClass: "text-danger",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytree.disclaimerFirstDegree
                                  )
                                }
                              })
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-body text-left" },
                          [
                            _c("h6", { staticClass: "card-title" }, [
                              _vm._v("Mottagare (en eller flera)")
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "small-right" }, [
                              _vm._v(
                                "Klicka på respektive namn för att markera"
                              )
                            ]),
                            _vm._v(" "),
                            _vm.aliveRelatives.length > 0 ? _c("hr") : _vm._e(),
                            _vm._v(" "),
                            _vm.aliveRelatives.length === 0
                              ? _c("div", [
                                  _vm._v(
                                    "\n                Inga släktingar tillgängliga.\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.aliveRelatives, function(relative, i) {
                              return _c("div", { key: i }, [
                                _c(
                                  "label",
                                  { staticClass: "custom-checkbox" },
                                  [
                                    _c("input", {
                                      staticClass: "custom-checkbox-input",
                                      attrs: {
                                        name: "selectedRelative",
                                        disabled: _vm.isRelativeInvited(
                                          relative
                                        ),
                                        type: "checkbox"
                                      },
                                      domProps: { value: relative },
                                      on: {
                                        change: function($event) {
                                          return _vm.addOrRemoveSelectedRelative(
                                            relative,
                                            i,
                                            $event
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "custom-checkbox-text",
                                      domProps: {
                                        textContent: _vm._s(
                                          relative.firstName +
                                            " " +
                                            relative.lastName
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ])
                            })
                          ],
                          2
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          attrs: {
                            disabled:
                              _vm.selectedRelatives.length === 0 ||
                              _vm.aliveRelatives === 0
                          },
                          on: {
                            click: function($event) {
                              return _vm.prepareInvites()
                            }
                          }
                        },
                        [_vm._v("\n          Nästa\n          ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-dark btn-lg btn-block",
                          on: {
                            click: function($event) {
                              return _vm.$router.go(-1)
                            }
                          }
                        },
                        [_vm._v("← Tillbaka")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v("Välj minst en mottagare för att gå vidare.")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("Bottom")
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d72d57b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d72d57b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FamilyTreeInvite.vue
// module id = null
// module chunks = 